/**
 * @module window
 * @desc   窗口相关
 * @author: Liang Huang
 * @date: 2019-06-04 16:44:37
 */
import shortid from 'shortid';

var PushN =
/** @class */
function () {
  function PushN() {
    this.notification = null;
  } // static getInstance() {
  //   if(!this['instance']) {
  //     this['instance'] = new PushN();
  //   }
  //   return this['instance'];
  // }


  PushN.prototype.getPermission = function () {
    var _this = this;

    return new Promise(function (resolve) {
      if (_this.isSupport()) {
        window.addEventListener('load', function () {
          if (Notification.permission !== 'granted') {
            Notification.requestPermission(function (permisson) {
              if (permisson === 'granted' || permisson === 'default') {
                resolve();
              }
            });
          }
        });
      }
    });
  }; // 是否支持Notifacation


  PushN.prototype.isSupport = function () {
    return !!window.Notification;
  };

  PushN.prototype.showNotice = function (title, msg, clickCb, closeCb) {
    var _this = this;

    this.notification = new Notification(title, {
      body: msg,
      tag: '1',
      requireInteraction: true
    });

    this.notification.onclick = function () {
      clickCb && clickCb();

      _this.notification.close();
    };

    this.notification.onclose = function () {
      closeCb && closeCb();

      _this.notification.close();
    };

    function addOnBeforeUnload(e) {
      this.notification.close();
    }

    if (window.attachEvent) {
      window.attachEvent('onbeforeunload', addOnBeforeUnload);
    } else {
      window.addEventListener('onbeforeunload', addOnBeforeUnload, false);
    }
  };

  PushN.prototype.show = function (title, msg, clickCb, closeCb) {
    var _this = this;

    this.getPermission().then(function () {
      _this.showNotice(title, msg, clickCb, closeCb);
    });
  };

  PushN.prototype.close = function () {
    this.notification && this.notification.close();
  };

  return PushN;
}();

var push = new PushN();
/**
 * 展示通知
 * @function
 * @param {string} title 推送标题
 * @param {string} msg 推送消息
 * @param {Function} clickCb 点击回调
 * @param {Function} closeCb 关闭回调
 */

export function NotificationShow(title, msg, clickCb, closeCb) {
  if (title === void 0) {
    title = '提示';
  }

  if (msg === void 0) {
    msg = '';
  }

  if (clickCb === void 0) {
    clickCb = function clickCb() {};
  }

  if (closeCb === void 0) {
    closeCb = function closeCb() {};
  } // const push = PushN.getInstance()


  if (push.isSupport()) {
    push.show(title, msg, clickCb, closeCb);
  } else {
    throw new Error('browser not support Notification API');
  }
}
/**
 * 关闭通知
 * @function
 */

export function NotificationClose() {
  // const push = PushN.getInstance()
  if (push.isSupport()) {
    push.close();
  } else {
    throw new Error('browser not support Notification API');
  }
} // 页面显示状态

var Visibility =
/** @class */
function () {
  function Visibility() {
    this.init();
    this.obj = {};
  }

  Visibility.prototype.init = function () {
    var _this = this; // 给document添加事件


    var visProp = this.getHiddenProp();

    if (visProp) {
      var evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange';
      document.addEventListener(evtname, function () {
        if (document[_this.getVisibilityState()] === 'visible') {
          for (var _i = 0, _a = Object.values(_this.obj); _i < _a.length; _i++) {
            var iterator = _a[_i];
            iterator.backCb && iterator.backCb();
          } // backCb && backCb();

        } else {
          for (var _b = 0, _c = Object.values(_this.obj); _b < _c.length; _b++) {
            var iterator = _c[_b];
            iterator.levelCb && iterator.levelCb();
          } // levelCb && levelCb();

        }
      }, false);
    }
  };

  Visibility.prototype.setCb = function (objId, levelCb, backCb) {
    if (levelCb === void 0) {
      levelCb = function levelCb() {};
    }

    if (backCb === void 0) {
      backCb = function backCb() {};
    }

    this.obj[objId] = {
      levelCb: levelCb,
      backCb: backCb
    };
    window.onpageshow = window.onfocus = backCb;
    window.onpagehide = window.onblur = levelCb;
  }; // 对document.hidden做前缀处理


  Visibility.prototype.getHiddenProp = function () {
    var prefixes = ['webkit', 'moz', 'ms', 'o']; // if 'hidden' is natively supported just return it

    if ('hidden' in document) return 'hidden'; // otherwise loop over all the known prefixes until we find one

    for (var i = 0; i < prefixes.length; i++) {
      if (prefixes[i] + 'Hidden' in document) return prefixes[i] + 'Hidden';
    } // otherwise it's not supported


    return null;
  }; // 获取document.visibilityState属性


  Visibility.prototype.getVisibilityState = function () {
    var prefixes = ['webkit', 'moz', 'ms', 'o'];
    if ('visibilityState' in document) return 'visibilityState';

    for (var i = 0; i < prefixes.length; i++) {
      if (prefixes[i] + 'VisibilityState' in document) return prefixes[i] + 'VisibilityState';
    } // otherwise it's not supported


    return null;
  };

  return Visibility;
}();

var visibility = new Visibility();
/**
 * 检测页面是前台还是后台运行
 * @function
 * @param {Function} levelCb 离开页面callback
 * @param {Function} backCb 回到页面callback
 */

export function bindVisiable(levelCb, backCb) {
  if (levelCb === void 0) {
    levelCb = function levelCb() {};
  }

  if (backCb === void 0) {
    backCb = function backCb() {};
  }

  visibility.setCb(shortid.generate(), levelCb, backCb);
}